import { createAction } from "redux-actions";
import { FIGHT_DATA_ACTIONS } from "../Actions/fightDataActions"
import { MODAL_DATA_ACTIONS } from "../Actions/modalActions"
 
export const GAME_DATA_ACTIONS = {
    SET_GAME_STATE: 'gameData set gameState',
    SET_COMMAND_BOX_FLAG: 'gameData set commandBoxFlag',
    SET_TO_FIGHT_MODE: 'gameData set to FightMode',
    SET_TO_NORMAL_MODE: 'gameData set to NormalMode',
    SET_TO_VICTORY_MODE: 'gameData set to VictoryMode',
    SWITCH_BACK_TO_OLD_GAME_STATE: 'gameData switch back to old gameState',
    SET_CITY_DATA: 'gameData set cityData',
    SET_EVENT_DATA: 'gameData set eventData',
    GENERATE_FIGHT_DATA: 'gameData generate fightData',
    SET_FIGHT_DATA_CURRENT_SELECTED_MONSTERS_INDEX: 'gameData set fightData currentMonstersIndex',
    FIGHT_DATA : FIGHT_DATA_ACTIONS,
    MODAL_DATA: MODAL_DATA_ACTIONS,
}

export const gameDataActions = {
    setGameState: createAction(GAME_DATA_ACTIONS.SET_GAME_STATE, (gameState) => ({ gameState })),
    setCommandBoxFlag: createAction(GAME_DATA_ACTIONS.SET_COMMAND_BOX_FLAG, (commandBoxFlag) => ({ commandBoxFlag })),
    setToFightMode: createAction(GAME_DATA_ACTIONS.SET_TO_FIGHT_MODE),
    setToNormalMode: createAction(GAME_DATA_ACTIONS.SET_TO_NORMAL_MODE),
    setToVictoryMode: createAction(GAME_DATA_ACTIONS.SET_TO_VICTORY_MODE),
    switchBackToOldGameState: createAction(GAME_DATA_ACTIONS.SWITCH_BACK_TO_OLD_GAME_STATE),
    setCityData: createAction(GAME_DATA_ACTIONS.SET_CITY_DATA, (cityData) => ({ cityData })),
    setEventData: createAction(GAME_DATA_ACTIONS.SET_EVENT_DATA, (eventData) => ({ eventData })),
    generateFightData: createAction(GAME_DATA_ACTIONS.GENERATE_FIGHT_DATA, (payload) => payload),
    setFightDataCurrentSelectedMonster: createAction(GAME_DATA_ACTIONS.SET_FIGHT_DATA_CURRENT_SELECTED_MONSTERS_INDEX, (monstersIndex) => ({ monstersIndex })),
    fightData: {
        monsterTakeDamageById : createAction(FIGHT_DATA_ACTIONS.MONSTER_TAKE_DAMAGE_BY_ID, (monstersIndex, amount) => ({ monstersIndex, amount })),
        removeMonsterByIndex: createAction(FIGHT_DATA_ACTIONS.REMOVE_MONSTER_BY_INDEX, (monstersIndex) => ({ monstersIndex })),
        isDataPlayerAttack: createAction(FIGHT_DATA_ACTIONS.IS_DATA_PLAYER_ATTACK, (attackData) => ({ attackData })),
        isDataPlayerSpecialAttack: createAction(FIGHT_DATA_ACTIONS.IS_DATA_PLAYER_SPECIAL_ATTACK, (specialAttackData) => ({ specialAttackData })),
        isDataPlayerEscape: createAction(FIGHT_DATA_ACTIONS.IS_DATA_PLAYER_ESCAPE, (isEscaping) => isEscaping),
        isDataPlayerInventory: createAction(FIGHT_DATA_ACTIONS.IS_DATA_PLAYER_INVENTORY, (inventoryData) => ({ inventoryData })),
        setEndFightData: createAction(FIGHT_DATA_ACTIONS.SET_END_FIGHT_DATA, (expDrop, goldDrop) => ({ expDrop, goldDrop })),
    },
    modalData: {
        switch: createAction(MODAL_DATA_ACTIONS.SWITCH, (showModal) => showModal ),
        setFlag: createAction(MODAL_DATA_ACTIONS.SET_FLAG, (flag) => flag ),
        setData: createAction(MODAL_DATA_ACTIONS.SET_DATA, (data) => ({ data }) ),
        set: createAction(MODAL_DATA_ACTIONS.SET, (showModal, flag, data) => ({ showModal, flag, data }))
    } 
}